import { lazy, Suspense, ComponentType } from "react";

import { Brand } from "../../../store/slices/environmentSlice";
import { useTypedSelector } from "../../../store/store";
import LoadingContainer from "../../containers/LoadingContainer";

const DefaultAgentRegistration = lazy(() => import("./default"));
const VIDAgentRegistration = lazy(() => import("./vid"));
const DTWAgentRegistration = lazy(() => import("./dtw"));
const CENAgentRegistration = lazy(() => import("./cen"));

const PAGES_BY_BRAND: Record<Brand, ComponentType> = {
  default: DefaultAgentRegistration,
  vid: VIDAgentRegistration,
  dtw: DTWAgentRegistration,
  aov: DefaultAgentRegistration,
  cen: CENAgentRegistration,
};

function RootAgentRegistration() {
  const { brand } = useTypedSelector((state) => state.environment);

  const PageByBrand = PAGES_BY_BRAND[brand] ?? DefaultAgentRegistration;

  return (
    <Suspense
      fallback={
        <LoadingContainer isLoading>
          <></>
        </LoadingContainer>
      }>
      <PageByBrand />
    </Suspense>
  );
}

export default RootAgentRegistration;
